import { render } from "./CandidateDashboard.vue?vue&type=template&id=5d99060b&scoped=true"
import script from "./CandidateDashboard.vue?vue&type=script&lang=js"
export * from "./CandidateDashboard.vue?vue&type=script&lang=js"

import "./CandidateDashboard.vue?vue&type=style&index=0&id=5d99060b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d99060b"]])

export default __exports__